/**
 * Trang placeholder cho các module chưa phát triển.
 * Hiển thị tên module, breadcrumb đơn giản và ghi chú "Coming soon".
 */
import { Box, Typography, Paper, Chip } from '@mui/material'
import { Construction } from '@mui/icons-material'
import { useLocation } from 'react-router-dom'
import { navigation } from '../config/navigation'
import type { NavItem } from '../config/navigation'

function findLabel(items: NavItem[], pathname: string, search: string): string[] {
  for (const item of items) {
    const fullPath = item.path
    if (fullPath.includes('?')) {
      const [base, qs] = fullPath.split('?')
      if (pathname === base && search.includes(qs)) return [item.label]
    } else if (pathname === fullPath && !item.children) {
      return [item.label]
    }
    if (item.children) {
      const sub = findLabel(item.children, pathname, search)
      if (sub.length > 0) return [item.label, ...sub]
    }
  }
  return []
}

export default function PlaceholderPage() {
  const location = useLocation()
  const crumbs = findLabel(navigation, location.pathname, location.search)
  const title = crumbs.length > 0 ? crumbs[crumbs.length - 1] : 'Module'

  return (
    <Box>
      {crumbs.length > 1 && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
          {crumbs.slice(0, -1).join(' / ')}
        </Typography>
      )}
      <Typography variant="h5" fontWeight={600} gutterBottom>
        {title}
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 4,
          mt: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          textAlign: 'center',
          borderStyle: 'dashed',
        }}
      >
        <Construction sx={{ fontSize: 48, color: 'text.secondary' }} />
        <Typography variant="h6" color="text.secondary">
          Module đang phát triển
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Phần <strong>{title}</strong> sẽ được triển khai trong giai đoạn tiếp theo.
        </Typography>
        <Chip label="Coming soon" size="small" color="warning" variant="outlined" />
      </Paper>
    </Box>
  )
}
